// @flow
import BookingAttendeesProfile from 'Components/widgets/contact-info/BookingAttendeesProfile.fragment';
import { getCxoAttendeesData } from 'Views/booking/BookingEngine.query';

export type FetchPrebookingTravelersParams = {
  adults?: Array<string>,
  kids?: Array<string>,
};

export function travelerProfilesQuery({ adults, kids }: FetchPrebookingTravelersParams) {
  return `
    {
      ${getCxoAttendeesData({ adultsAttendeesIds: adults, kidsAttendeesIds: kids })}
    }
    ${(adults && adults[0]) || (kids && kids[0]) ? BookingAttendeesProfile : ''}
  `;
}
